import { Dialog, IconButton } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import styles from "./ThanksModal.module.css";
// import { useState } from "react";
import ThanksView from "../Thanks/Thanks";

export interface IThanksModal {
  /* Controls to open the modal */
  isOpen: boolean;
  /* Callback to update the isOpen on the parent*/
  handleOnClose: () => void;
  /* URL to redirect */
  urlRedirect: string;
}

/* Custom style for Dialog */
const useStyles = makeStyles((theme: Theme) => ({
  paper: { maxWidth: "624px", width: "100%" },
  titleText: {
    color: theme.palette.secondary.light,
    fontWeight: 600,
    marginLeft: 8,
  },
}));

const ThanksModal: React.FC<IThanksModal> = ({
  isOpen = true,
  handleOnClose,
  urlRedirect,
}) => {
  // Custom styles
  const classes = useStyles();

  const completeCallback = () => {
    window.open(urlRedirect, "_blank", "noopener,noreferrer");
    handleOnClose();
  }

  return (
    <Dialog
      data-qatag="Dialog"
      open={isOpen}
      onClose={completeCallback}
      fullWidth
      classes={{ paper: classes.paper }}
    >
      {/* Close Icon */}
      <div
        data-qatag="closeIconContainer"
        className={styles.closeIconContainer}
      >
        <IconButton
          data-qatag="closeIcon"
          aria-label="close"
          onClick={completeCallback}
          className={styles.closeIcon}
        >
          <CloseIcon data-qatag="CloseIcon" />
        </IconButton>
      </div>
      <ThanksView
        className={styles.customThanks}
        title="Thank you for joining!"
        onGetStarted={completeCallback}
      />
    </Dialog>
  );
};

export default ThanksModal;
